export class ServerDicObj {
    noOfServers: number;
    noOfLicenses: number;
    vmName: string;
    perMonthCost: number;
    planID: string;

    constructor(noOfServer = 0, noOfLicenses = 0, vmName = '', perMonthCost = 0, planID = '') {
        this.noOfServers = noOfServer;
        this.noOfLicenses = noOfLicenses;
        this.vmName = vmName;
        this.perMonthCost = perMonthCost;
        this.planID = planID;
    }
}